import { IAudienceSearch, MultiRfmSearch } from 'types/api/audience/search';

export const defaultSearch = (defaultSortField = 'lastName'): IAudienceSearch => ({
  categoryJson: null,
  page: 1,
  pageSize: 10,
  sort: {
    direction: 'asc',
    field: defaultSortField,
  },
});

export const defaultSearchMultiRfm = (defaultSortField = 'lastName'): MultiRfmSearch => ({
  page: 1,
  pageSize: 10,
  rfmSets: [],
  sort: {
    direction: 'asc',
    field: defaultSortField,
  },
});
